export default __webpack_public_path__ + "static/media/Ni_2020-4-1.3077c828.png";